'use strict';
const angular = require('angular');

/*@ngInject*/
export function EFormsService($resource) {
  return $resource('/api/e-forms/:id', {
    name: '@_id'
  },{
    update: {
      method: 'PUT'
    },
    getByForm: {
      method: 'GET',
      url: "/api/e-forms/form/:name",
      isArray: true
    }
  });
}


export default angular.module('conduu.EFormsService', [])
  .factory('EFormsService', EFormsService)
  .name;



// WEBPACK FOOTER //
// ./client/components/eforms/eforms.service.js